import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import {
  createSelectedItemsSlice,
  type SelectedItemsState,
} from "features/Application/slices/createSelectedItemsSlice";
import { type ScormUser } from "../../types/models";

export interface UsersState extends SelectedItemsState<ScormUser> {}

const initialState: UsersState = {
  items: [],
  itemsCount: 0,
  selectedIds: [],
  isLoading: false,
  error: undefined,
  selectedItems: [],
};

const usersSlice = createSelectedItemsSlice(
  { namespace: ReducerNamespaceTypes.Library, entity: ReducerEntityPrefixTypes.SCORM, name: "users" },
  initialState,
);

export const { fetchBegin, fetchSuccess, fetchFailure, selectedItemsChanged, resetSelectedItems } = usersSlice.actions;

export default usersSlice.reducer;
